import React from 'react'
import {
  Button,
  ButtonContainer,
  ButtonSentiment,
  ButtonSize,
} from 'sidecar-components'

import { formTitles } from 'utils/memberComm/formTitles'

export const ProviderPLA = ({ setPoptartHistory, testId }) => {
  const { ADDITIONAL_INSURANCE, PRE_CHECKED_PROVIDERS } = formTitles
  return (
    <div data-testid={testId}>
      <h4>Do you have additional health insurance?</h4>
      <p>
        Most people have only one insurance, but some have more through a family
        member or Medicare/Medicaid. If you have multiple insurances, it's best
        to find a provider in your other insurance's network.
      </p>
      <ButtonContainer>
        <Button
          testId="btn_onlyHaveSidecar_memberComm"
          onClick={() => {
            setPoptartHistory(PRE_CHECKED_PROVIDERS)
          }}
          sentiment={ButtonSentiment.PRIMARY}
          size={ButtonSize.SMALL}
          width="full"
        >
          I only have Sidecar Health
        </Button>
        <Button
          testId="btn_additionalInsurance_memberComm"
          onClick={() => setPoptartHistory(ADDITIONAL_INSURANCE)}
          sentiment={ButtonSentiment.SECONDARY}
          size={ButtonSize.SMALL}
          width="full"
        >
          I have additional health insurance
        </Button>
      </ButtonContainer>
    </div>
  )
}
